import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ViewEncapsulation, Renderer2, ChangeDetectorRef } from '@angular/core';
import { State } from '@progress/kendo-data-query';
import { GridComponent, ColumnComponent } from '@progress/kendo-angular-grid';
import { v_DispatchBus } from '../../shared/models/v_DispatchBus';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { v_DispatchNoteBus } from '../../shared/models/v_DispatchNoteBus';
import { NoteUpd } from '@app/cp/shared/models/NoteUpd';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { DispatchNoteBus } from '@app/cp/shared/models/DispatchNoteBus';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

const matches = (el, selector) => (el.matches || el.msMatchesSelector).call(el, selector);

@Component({
    selector: 'dispatch-notes',
    templateUrl: './dispatch-notes.component.html',
    styleUrls: ['./dispatch-notes.component.scss'],
    standalone: false
})
export class DispatchNotesComponent extends BaseGridEditLineComponent<v_DispatchNoteBus, null, DispatchesService> {
    @Input() IsInjury: boolean = false;
    @Input() canEditOthersNotes: boolean = false;
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "v_DispatchNoteBus";
        this.appCode = "DispatchNotes";
        this.pageSize = 10;
        //necessary for grid displays that dont search
        this.disableCpSearchDialog();
    }
   createForm() {
        this.editForm = new UntypedFormGroup({
            'dispatchNotesId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'dispatchNotes': new UntypedFormControl(),
            'visibleToCustomer': new UntypedFormControl(),
            'highlight': new UntypedFormControl(),
            'isWarning': new UntypedFormControl(), 
            'techNote': new UntypedFormControl(),
            'dispatchNotesPersonId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updatedt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),

        });
    }
    setForm() {
        this.editForm.patchValue({
            dispatchNotesId: this.selectedData.dispatchNotesId,
            dispatchId: this.selectedData.dispatchId,
            dispatchNotes: this.selectedData.dispatchNotes,
            visibleToCustomer: this.selectedData.visibleToCustomer,
            highlight: this.selectedData.highlight,
            isWarning: this.selectedData.isWarning,
            techNote: this.selectedData.techNote,
            dispatchNotesPersonId: this.selectedData.dispatchNotesPersonId,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updatedt: this.selectedData.updatedt,
            updateUserId: this.selectedData.updateUserId
        });
    }

    get canEditNote(): boolean {
        let can: boolean = false;

        if (this.canEdit && this.selectedData) {
            if (this.selectedData.dispatchNotesPersonId == this.globals.personId || this.rights.EditOthersNotes) {
                can = true;
            }
        }

        return can;
    }
    hasRowEditRights(dataItem: v_DispatchNoteBus): boolean {
        return super.hasRowEditRights(dataItem) && this.canEditNote;
    }

    protected getChangedObject(dataObj: v_DispatchNoteBus) {
        let busObj: DispatchNoteBus = new DispatchNoteBus(dataObj);
        busObj.dispatchNotes1 = dataObj.dispatchNotes;
        if (this.IsInjury) {
            busObj.isWarning = true;
        }
        return busObj;
    }
    protected save(dataObj: v_DispatchNoteBus) {

        let busObj: DispatchNoteBus = this.getChangedObject(dataObj);
        //   busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        //   busObj.setParentId(this._parentId);
        //  data.referenceId = this._parentId;
        this.svc_data.saveNote(busObj).subscribe((data: DispatchNoteBus) => {
            if (data != null) {
                let newDataObj: v_DispatchNoteBus = new v_DispatchNoteBus();
                newDataObj.setFromBusobj(data);
                newDataObj.dispatchNotes = data.dispatchNotes1;
                //newDataObj.visibleToCustomer = data.visibleToCustomer;
                this.saveSuccess(newDataObj);
            }
            else {
                this.saveError(dataObj, "Error Saving");
            }
        });
    }
    customCheckBoxChanged(e: any, dataItem, rowIndex, column, columnIndex) {
        if (column.field === "visibleToCustomer") {
            this.editForm.patchValue({
                visibleToCustomer: e.target.checked
            });

        }
        if (column.field === "highlight") {
            this.editForm.patchValue({
                highlight: e.target.checked
            });

        }
    }
    deleteIndividual(data: v_DispatchNoteBus) {
        if (data.hasId) {
            this.svc_data.deleteNote(data.dispatchNotesId).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    let delDataObj: v_DispatchNoteBus = new v_DispatchNoteBus(data);

                    this.deleteSuccess(delDataObj);
                    this.removeLocal(delDataObj);
                }
                else {
                    this.deleteError(data, dataObj.message);

                }
            });
        }
        else {
            this.closeEditor();
        }
    }
}

